/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { getTheme, FontSizes, FontWeights } from "office-ui-fabric-react";
import styled from "styled-components";

const theme = getTheme();

/**
 * Flex column styles.
 */
export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

/**
 * Styles for result counts text
 */
export const Title = styled.p`
  font-size: ${FontSizes.size20};
  font-weight: ${FontWeights.semibold};
  color: ${theme.palette.black};
  flex-grow: 2;
`;
